import { DateTime } from 'luxon';
import { getHoursDifference } from '@amzn/atoz-dashboard-taa-components';
var missedPunchGracePeriod = 8;
export var useDaysWithMissedPunch = function (_a) {
    var punchesTimeSegments = _a.punchesTimeSegments, isPendingPunchesOnTimecardEnabled = _a.isPendingPunchesOnTimecardEnabled;
    return ((punchesTimeSegments === null || punchesTimeSegments === void 0 ? void 0 : punchesTimeSegments.filter(function (punch) { return !punch.startDateTime || !punch.endDateTime; }).map(function (punch) {
        if (punch.startDateTime &&
            !(isPendingPunchesOnTimecardEnabled &&
                getHoursDifference(punch.startDateTime, DateTime.now().toISO()) < missedPunchGracePeriod)) {
            return DateTime.fromISO(punch.startDateTime);
        }
        if (punch.endDateTime) {
            return DateTime.fromISO(punch.endDateTime);
        }
        return null;
    }).filter(function (dateTime) { return !!dateTime; })) || []);
};
